import React, { useContext } from 'react';
import tw from 'twin.macro';
import { AppContext } from '../context';

export const ScrollBarContent = ({ children, ...restProps }) => {
  const { windowSize } = useContext(AppContext);
  return (
    <div
      css={[
        tw`h-full overflow-y-auto`,
        !['MOBILE'].includes(windowSize.adBreakPoint) &&
          tw`scrollbar-thin scrollbar-thumb-icons scrollbar-track-primary
    scrollbar-thumb-rounded-full scrollbar-track-rounded-full pr-2 overflow-x-hidden`,
      ]}
      {...restProps}
    >
      {children}
    </div>
  );
};
